import { useContext } from 'react';
import { useParams } from 'react-router-dom';

import styled from '@emotion/styled';

import PrimaryButton from '../../../components/Button/PrimaryButton';
import TableBackComponent from '../../../components/TableCom/TableBackComponent';
import { ModalContext } from '../../../context/ModalContext';
import { capitalize } from '../../../utils/utils';

const CreateAreaPrice = () => {
  const modalContext = useContext(ModalContext);
  const { state } = useParams();
  const { warehouseName } = useParams();

  const createUserHandler = (e: any) => {
    modalContext?.displayModal(true);
  };

  return (
    <Container>
      <TableBackComponent
        text={`Areas under ${warehouseName} in ${capitalize(state!)}`}
        path="/warehouse"
      />
      <PrimaryButton className="fitContent" onClick={createUserHandler}>
        Create Area Price
      </PrimaryButton>
    </Container>
  );
};

export default CreateAreaPrice;

const Container = styled.div`
  display: flex;
  /* border: 2px solid red; */
  justify-content: space-between;
  align-items: center;
`;
